import { cn } from "~/lib/utils";

/** Circular Linear icon control used by expanding search, Display, and New. */
export const PLANNING_ICON_CONTROL =
  "inline-flex size-7 shrink-0 items-center justify-center rounded-full border transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

export const PLANNING_ICON_CONTROL_IDLE =
  "border-border bg-transparent text-muted-foreground hover:bg-muted hover:text-foreground";

export const PLANNING_ICON_CONTROL_ACTIVE = "border-transparent bg-muted text-foreground";

export const PLANNING_ICON_CONTROL_PRIMARY =
  "border-transparent bg-foreground text-background hover:opacity-90";

export function planningIconControlClass(opts: {
  readonly active?: boolean;
  readonly primary?: boolean;
  readonly className?: string;
}): string {
  if (opts.primary) {
    return cn(PLANNING_ICON_CONTROL, PLANNING_ICON_CONTROL_PRIMARY, opts.className);
  }
  return cn(
    PLANNING_ICON_CONTROL,
    opts.active ? PLANNING_ICON_CONTROL_ACTIVE : PLANNING_ICON_CONTROL_IDLE,
    opts.className,
  );
}
